import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Button, ButtonVariants } from '../../Atoms/Button';
import { ButtonGroupWrapper } from './styles';

type ButtonGroupButtonType = {
  key: string;
  placeholder: string;
  hidden?: boolean;
};

export type ButtonArray = Array<ButtonGroupButtonType>;

interface ButtonGroupProps {
  spaced?: boolean;
  buttons: ButtonArray;
  variant: ButtonVariants;
  onClick: React.EventHandler<React.MouseEvent | React.TouchEvent>;
  rounded?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  space?: number;
  buttonClassName?: string;
  className?: string;
  defaultSelectedIndex?: number;
  changeInterval?: (key: string) => void;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  spaced = false,
  buttons,
  variant,
  onClick,
  rounded = 'lg',
  buttonClassName = '',
  className = '',
  space = 8,
  defaultSelectedIndex = 0,
  changeInterval,
}) => {
  const [clickedId, setClickedId] = useState(
    defaultSelectedIndex < buttons.length ? defaultSelectedIndex : 0
  );

  const wrapperClasses = classNames({
    [`${className}`]: !!className,
  });

  const buttonClasses = classNames({
    'spaced': spaced,
    'no-spaced': !spaced,
    [`${buttonClassName}`]: !!buttonClassName,
  });

  const handleClick = (
    event: React.MouseEvent | React.TouchEvent,
    id: number
  ) => {
    setClickedId(id);
    onClick(event);
  };

  useEffect(() => {
    const newId =
      defaultSelectedIndex < buttons.length ? defaultSelectedIndex : 0;
    setClickedId(newId);

    if (changeInterval && buttons[newId]) changeInterval(buttons[newId].key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultSelectedIndex, buttons]);

  return (
    <ButtonGroupWrapper
      rounded={rounded}
      space={space}
      className={wrapperClasses}
    >
      {buttons.map((buttonData, i) => (
        <Button
          id={buttonData.key}
          key={buttonData.key}
          name={buttonData.placeholder}
          // disabled={i === clickedId ? false : true}
          variant={variant}
          onClick={(event) => handleClick(event, i)}
          rounded={rounded}
          className={`${buttonClasses} ${
            i !== clickedId ? 'button-light-noborder' : ''
          } ${buttonData.hidden ? 'hidden' : ''} sm:px-4`}
        >
          {buttonData.placeholder}
        </Button>
      ))}
    </ButtonGroupWrapper>
  );
};

export { ButtonGroup };
